<script setup lang="ts">

import type { metaField, ColorMetaField } from "../../../types/metas"
import { reactive } from "vue"


const emits = defineEmits(['metaAdded', 'metaUpdated'])
const props = defineProps(["existingMeta", "metaTitle" , "hasColor"])


const meta = reactive<metaField | ColorMetaField>({
    id: props.existingMeta?.id ?? "",
    name: props.existingMeta?.name ?? "",
    color: props.existingMeta?.color ?? "",
})

const emitAddMeta = () => {
    if (!meta.name) { 
        alert("Lütfen müşteri durumu adını giriniz.")
    } else {
       if(props.hasColor){
        emits('metaAdded', {name: meta.name, color: meta.color})
       } else {
        emits('metaAdded', {name: meta.name})
       }
    }
}

const emitUpdateMeta = () => {
    if (!meta.name) { 
        alert("Lütfen müşteri durumu adını giriniz.")
    } else {
        emits('metaUpdated', meta)
    }
}

const handleFormSubmit = () => {
    if (props.existingMeta) {
        emitUpdateMeta()
    } else {
        emitAddMeta()
    }
}

</script>

<template>
    <form class="ac-main-form !border-none">
        <div class="ac-form-control">
            <label for="title">
         {{ props.metaTitle }} Adı
            </label>
            <input type="text" id="title" class="" v-model="meta.name">
        </div>

        <div v-if="props.hasColor" class="ac-form-control">
            <label for="color">
                Renk
            </label>
            <input type="color" id="color" class="w-full" v-model="meta.color">
        </div>
        <div class="ac-form-control">
            <button type="button" class="ac-primary-button w-2/6" @click="handleFormSubmit">
                <span v-if="!existingMeta"> 
                    {{ props.metaTitle }} Oluştur </span>
                <span v-else> {{ props.metaTitle }} Güncelle </span>
            </button>
        </div>

    </form>
</template>